export const renderPdfModule = (str) => ({
  type: 'RENDER_PDF_MODULE',
  str
})
